import v8n from 'v8n'
import { getInitializedApp, } from '@/assets/js/src/util/appRef'
import { Logger, } from '@/assets/js/src/util/logger'

/**
 * Dies erweitert den v8n, um die Funktion "checkType", um Objekte auf eine Schema zu prüfen
 *
 * Schema ist selbst ein Objekt, was andere ObjektType, ähnlich wie Props bei Vue beschreibt
 * (z.B:
 * userProps = {
 *   email: {
 *       type: String,
 *       default: '',
 *       validator: v8n().string()
 *   },
 *   plain_password: {
 *       type: String,
 *       default: '',
 *       validator: v8n().string()
 *   }
 *})
 */
v8n.extend({
    checkType: (schema) => {
        return (value) => {
            const causes = []

            let schemaKeys = Object.keys(schema)
            let valueKeys = Object.keys(value)
            if (valueKeys.length !== schemaKeys.length) {
                causes.push('Object Properties don\'t match')
            }
            schemaKeys.forEach((key) => {
                const nestedValidation = schema[key]
                try {
                    nestedValidation.check((value || {})[key])
                } catch (ex) {
                    ex.target = key
                    ex.targetvalue = value
                    causes.push(ex)
                }
            })
            if (causes.length > 0) {
                if (import.meta.env.DEV) {
                    causes.forEach((cause) => {
                        Logger.error({
                            cause,
                            target: cause.target,
                        })
                    })
                }
                throw causes
            }

            return true
        }
    },
})

/**
 * Folgend einige allgemeine Validierungsregeln
 */

const emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/

const emailRules = [
    (v) => {
        let { i18n, } = getInitializedApp()

        return v8n()
            .not.empty()
            .test(v) || (i18n && i18n.t('async.user.form.email.error.required'))
    },

    (v) => {
        let { i18n, } = getInitializedApp()

        return emailRegex.test(v) || (i18n && i18n.t('async.user.form.email.error.valid'))
    },
]

function emailRulesTest (email) {
    return [
        (v) => {
            let { i18n, } = getInitializedApp()

            return v8n()
                .equal(email())
                .test(v) || (i18n && i18n.t('async.user.form.email.error.equal'))
        },
    ]
}

const plain_passwordRules = [
    (v) => {
        let { i18n, } = getInitializedApp()

        return v8n()
            .minLength(1)
            .test(v) || (i18n && i18n.t('async.user.form.password.error.required'))
    },
    (v) => {
        let { i18n, } = getInitializedApp()

        return v8n()
            .not.empty()
            .test(v) || (i18n && i18n.t('async.user.form.password.error.required'))
    },
    (v) => {
        let { i18n, } = getInitializedApp()

        return v8n()
            .string()
            .minLength(6)
            .test(v) || (i18n && i18n.t('async.user.form.password.error.valid'))
    },
]

const passwordRulesTest = (password) => [
    (v) => {
        let { i18n, } = getInitializedApp()

        return v8n()
            .not.empty()
            .equal(password())
            .test(v) || (i18n && i18n.t('async.user.form.password.error.equal'))
    },
]

const termsRules = [
    (v) => {
        let { i18n, } = getInitializedApp()

        return v8n()
            .exact(true)
            .test(v) || (i18n && i18n.t('async.user.form.privacy.error.required'))
    },
]

export {
    v8n,
    emailRules,
    plain_passwordRules,
    termsRules,
    passwordRulesTest,
    emailRulesTest,
}
